export default __webpack_public_path__ + "static/media/Food_05.adf4a45a.png";